import classnames from 'vestClassnames';

const validator = (suiteName, onInit = null) => ({
  data: {},
  result: {},
  errors: {},
  warnings: {},
  messages: {},
  classes: {},
  suite: {},

  init() {
    this.suite = window.validationSuites[suiteName];
    if (!this.suite) {
      console.error("Validation suite not found: " + suiteName);
      return;
    }

    if (onInit !== null) {
      onInit();
    }
  },

  validate(e) {
    this.suite(this.data, e.target.name)
      .done((result) => this.setClass(result, e.target.name))
      .done((result) => this.setMessages(result, e.target.name))
      .done(this.handleResult.bind(this));
  },

  validateForm() {
    const result = this.suite(this.data).done((result) => {
      for (let [key, value] of Object.entries(result.tests)) {
        this.setClass(result, key);
        this.setMessages(result, key);
      }
    });
    return result;
  },

  handleResult(result) {
    this.errors = result.getErrors();
    this.warnings = result.getWarnings();
  },

  setMessages(result, name) {
    const message = [...result.getErrors(name), ...result.getWarnings(name)];
    if (message && message.length > 0) {
      this.messages[name] = message[0];
    } else {
      this.messages[name] = "";
    }
  },

  setClass(result, name) {
    const cn = classnames(result, {
      valid: "form-success",
      invalid: "form-error",
      warning: "form-warning",
    });

    for (let [key, value] of Object.entries(result.tests)) {
      if (name === key) {
        const classValue = { [key]: cn(key) };
        this.classes = { ...this.classes, ...classValue };
      }
    }
  },

  onSubmit(e, callback) {
    const result = this.validateForm();
    
    if (!result.valid) {
      e.preventDefault();
    } else {
      
      if (callback) {
        callback();
      }

      const form = document.getElementById('applyform');
      form.submit();
    }
  },
});

export { validator };
